<fgb-transfer-arena-multiple-accounts [transferAccounts]="transferAccounts$ | async"></fgb-transfer-arena-multiple-accounts>
